import React from "react";
import { Drawer } from "@material-ui/core";
import { CarbonCreditCardLogic } from "./carbonCreditCard.module";
import OffsetForm from "./OffsetForm";
import {
  NftTableService,
  csv,
  ftp,
  NftTableLogic,
} from "../shared/NftTable/NftTable.module";
import DrawenNftTable from "./../shared/NftTable/DrawenNftTable";
import SBTCard from "../shared/sbtCard/SBTCard";
import NFTCard from "../shared/nftCard/NFTCard";

const CarbonCreditCard = (props) => {
  const { translator } = CarbonCreditCardLogic();

  const {
    mostrarCertificate,
    handleGenerateCertificate,
    certificateUrl,
    showOffsetForm,
    handleOffsetClick,
  } = NftTableService(props);

  const {
    loadingCsvItemId,
    loadingGhgItemId,
    drawerOpen,
    toggleDrawer,
    carbonFluxData,
    handleCsvClick,
    handleGhgClick,
  } = NftTableLogic(props);

  const sharedProps = {
    ...props,
    mostrarCertificate,
    handleGenerateCertificate,
    certificateUrl,
    handleOffsetClick,
    toggleDrawer,
  };

  return (
    <div>
      {showOffsetForm ? (
        <OffsetForm id={props.id} user={props.user} />
      ) : (
        <>
          {props.is_sbt ? (
            <SBTCard {...sharedProps} />
          ) : (
            <NFTCard {...sharedProps} />
          )}
        </>
      )}

      <Drawer anchor="bottom" open={drawerOpen} onClose={toggleDrawer(false)}>
        <DrawenNftTable
          carbonFluxData={carbonFluxData}
          translator={translator}
          handleCsvClick={handleCsvClick}
          handleGhgClick={handleGhgClick}
          loadingCsvItemId={loadingCsvItemId}
          loadingGhgItemId={loadingGhgItemId}
          csv={csv}
          ftp={ftp}
          toggleDrawer={toggleDrawer}
        />
      </Drawer>
    </div>
  );
};

export default CarbonCreditCard;
